<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Cadastro de Produtos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary lighten-3"
            @click="cancelar"
            :disabled="salvando"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary lighten-5"
            class="ml-2"
            :disabled="!form_valid && gradePreenchida"
            :loading="salvando"
            @click="salvar"
            >Salvar</v-btn
          >
        </v-app-bar>
        <v-form ref="form" v-model="form_valid" lazy-validation>
          <v-container fluid class="pa-2">
            <v-row v-show="loading">
              <v-col
                class="ma-6 pa-6"
                style="display: flex; align-items: center; justify-content: center; text-align: center"
              >
                <v-progress-circular
                  size="64"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-col>
            </v-row>
            <v-row v-show="user.tipo == 'master'">
              <v-col cols="12">
                <v-text-field
                  label="Fornecedor"
                  v-model="produto.fornecedor"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense v-show="!loading">
              <v-col cols="12" sm="2" class="pa-3">
                <v-text-field
                  label="Código"
                  type="tel"
                  @blur="removerCaracteres"
                  ref="codigo"
                  v-model="produto.codigo"
                  autofocus
                  @keypress.native.enter="$refs.descricao.focus()"
                  :rules="regras_produto.codigo"
                  hint="Apenas números"
                  autocomplete="off"
                  role="presentation"
                  placeholder=" "
                  persistent-placeholder
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="8" class="pa-3">
                <v-text-field
                  label="Descrição"
                  ref="descricao"
                  v-model="produto.descricao"
                  @blur="produto.descricao = produto.descricao.trim()"
                  @keypress.native.enter="$refs.valor.focus()"
                  :rules="regras_produto.descricao"
                  autocomplete="off"
                  role="presentation"
                  placeholder=" "
                  persistent-placeholder
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" class="pa-3">
                <as-campo-valor
                  label="Valor"
                  ref="valor"
                  v-model="produto.valor"
                  :rules="regras_produto.valor"
                  @keypress.native.enter="$refs.categoria_id.focus()"
                  autocomplete="off"
                  role="presentation"
                  placeholder=" "
                  persistent-placeholder
                ></as-campo-valor>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="8" class="pa-3 pt-0">
                <v-autocomplete
                  v-model="produto.categoria_id"
                  ref="categoria_id"
                  :items="categorias"
                  label="Categoria"
                  :rules="regras_produto.categoria"
                  item-text="nome"
                  item-value="id"
                  :loading="loading_categorias"
                  @keypress.native.enter="$refs.multiplo.focus()"
                  autocomplete="off"
                  role="presentation"
                  placeholder=" "
                  persistent-placeholder
                />
              </v-col>
              <v-col cols="12" sm="2" class="pa-3 pt-0">
                <v-text-field
                  label="Múltiplo de Quantidade"
                  ref="multiplo"
                  v-model="produto.multiplo"
                  :rules="regras_produto.multiplo"
                  type="number"
                  @keypress.native.enter="$refs.quantidade_minima.focus()"
                  autocomplete="off"
                  role="presentation"
                  placeholder=" "
                  persistent-placeholder min="0"
                >
                  <template v-slot:prepend>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <p>Só permite que este produto seja comprado com uma quantidade múltipla deste valor</p>
                      <p>Ex: Múltiplo = 5 (Quantidades válidas: 5, 10, 15, 20, 25...)</p>
                      <p>Ex: Múltiplo = 15 (Quantidades válidas: 15, 30, 45, 60, 75...)</p>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="2" class="pa-3 pt-0">
                <v-text-field
                  label="Quantidade Mínima"
                  ref="quantidade_minima"
                  v-model="produto.quantidade_minima"
                  :rules="regras_produto.quantidade_minima"
                  type="number"
                  @blur="converterInteiro"
                  @keypress.native.enter="$refs.detalhes.focus()"
                  autocomplete="off"
                  role="presentation"
                  placeholder=" "
                  persistent-placeholder min="0"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" class="pa-3 pt-0">
                <v-text-field
                  label="Detalhes"
                  hint="Composição e demais detalhes"
                  ref="detalhes"
                  v-model="produto.detalhes"
                  @blur="produto.detalhes = produto.detalhes.trim()"
                  :rules="regras_produto.detalhes"
                  @keypress.native.enter="abrirDialogoGrade"
                  autocomplete="off"
                  role="presentation"
                  placeholder=" "
                  persistent-placeholder
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- <v-row dense v-if="loading">
              <v-col cols="12" sm="10" class="pa-3 py-7">
                <v-progress-linear
                  indeterminate
                  size="50"
                  width="3"
                  color="primary"
                  rounded
                  height="6"
                  class="my-auto"
                ></v-progress-linear>
              </v-col>
            </v-row>-->

            <v-row dense>
              <v-col cols="12" class="pa-3" flex>
                <v-btn
                  depressed
                  color="primary"
                  @click="abrirDialogoGrade"
                  block
                  style="min-width: 150px !important"
                  class="ml-auto"
                  right
                  :loading="loading_grade"
                  :disabled="loading_grade"
                  >Tamanhos e Cores</v-btn
                >
              </v-col>
            </v-row>

            <v-row
              dense
              v-show="produto.tamanhos.length > 0 && produto.cores.length > 0"
            >
              <v-col cols="12" class="pa-3 pt-0">
                <v-card class="tabela" width="inherit">
                  <div class="zui-wrapper">
                    <div class="zui-scroller pa-0">
                      <table
                        class="v-datatable v-table theme--light zui-table"
                        style="border-radius: 4px"
                      >
                        <thead style="border-radius: 4px">
                          <tr style="border-radius: 4px">
                            <th
                              class="zui-sticky-col primary lighten-1 pa-4"
                              style="border-radius: 4px 0px 0px 0px; color: white !important; font-weight: 600; width: 100%"
                            >
                              CORES
                            </th>
                            <th
                              v-for="(tamanho, index) in produto.tamanhos"
                              v-bind:key="tamanho.id"
                              class="primary lighten-2"
                              :style="
                                index === produto.tamanhos.length - 1 &&
                                index > 8
                                  ? 'color: white !important; font-weight: 600; border-radius: 0px 4px 0px 0px; width: 100%'
                                  : 'color: white !important; font-weight: 600; width: 100%'
                              "
                            >
                              {{ tamanho.tamanho }}
                            </th>
                            <template v-if="produto.tamanhos.length <= 8">
                              <th
                                v-for="n in 8 - produto.tamanhos.length"
                                v-bind:key="n"
                                :style="
                                  n === 8 - produto.tamanhos.length
                                    ? 'border-radius: 0px 4px 0px 0px; width: 100%'
                                    : 'width: 100%'
                                "
                              ></th>
                            </template>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="cor in produto.cores" v-bind:key="cor.id">
                            <td
                              class="zui-sticky-col"
                              style="background-color: white; z-index: 1"
                            >
                              {{ cor.nome }}
                            </td>
                            <td
                              v-for="n in produto.tamanhos.length +
                                (8 - produto.tamanhos.length > 0
                                  ? 8 - produto.tamanhos.length
                                  : 0)"
                              v-bind:key="n"
                              :style="
                                n > produto.tamanhos.length
                                  ? 'background-color: whitesmoke'
                                  : ''
                              "
                            >
                              <v-icon v-if="n <= produto.tamanhos.length"
                                >mdi-check</v-icon
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>

      <as-dialogo
        ref="dialogoGrade"
        title="Grade do Produto"
        max-width="800px"
        hideCloseButton
        altura="454px"
        sem-padding
        hideDivider
      >
        <v-container
          fluid
          v-show="!loading_grade"
          grid-list-lg
          class="pa-3 pb-0"
        >
          <v-row dense>
            <v-col cols="12" sm="6" class="pa-2 pt-0">
              <v-card>
                <v-app-bar color="primary" flat dark dense>
                  <v-toolbar-title>Cores</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                    fab
                    small
                    class="mr-2"
                    color="primary lighten-4"
                    @click="tooglePesquisaCores"
                  >
                    <v-icon>search</v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    small
                    color="primary lighten-4"
                    @click="abrirDialogoCores"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-app-bar>
                <v-expand-transition>
                  <v-row dense v-show="exibir_pesquisa_cores" class="pa-2">
                    <v-col cols="12">
                      <v-text-field
                        dense
                        ref="pesquisa_cores"
                        label="Pesquisa"
                        v-model="pesquisa_cores"
                        prepend-inner-icon="search"
                        solo
                        clearable
                        single-line
                        hide-details
                        placeholder="Pesquisa"
                        dark
                        background-color="primary lighten-2"
                        @click:clear="tooglePesquisaCores"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-expand-transition>
                <v-card-text
                  :style="
                    exibir_pesquisa_cores ? 'height: 322px' : 'height: 384px'
                  "
                  style="overflow-x: auto"
                  class="pa-0"
                >
                  <v-divider></v-divider>
                  <v-data-table
                    :search="pesquisa_cores"
                    :headers="headers_cores"
                    :items="cores"
                    item-key="id"
                    v-model="cores_selecionadas"
                    hide-default-footer
                    show-select
                    disable-pagination
                  >
                    <template slot="items" slot-scope="props">
                      <td>
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                          single-line
                        ></v-checkbox>
                      </td>
                      <td>{{ props.item.nome }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" class="pa-2 pt-0">
              <v-card>
                <v-app-bar color="primary" flat dark dense>
                  <v-toolbar-title>Tamanhos</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                    fab
                    small
                    class="mr-2"
                    color="primary lighten-4"
                    @click="tooglePesquisaTamanhos"
                  >
                    <v-icon>search</v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    small
                    color="primary lighten-4"
                    @click="abrirDialogoTamanhos"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-app-bar>
                <v-expand-transition>
                  <v-row dense v-show="exibir_pesquisa_tamanhos" class="pa-2">
                    <v-col cols="12">
                      <v-text-field
                        dense
                        ref="pesquisa_tamanhos"
                        label="Pesquisa"
                        v-model="pesquisa_tamanhos"
                        prepend-inner-icon="search"
                        solo
                        clearable
                        single-line
                        hide-details
                        placeholder="Pesquisa"
                        dark
                        background-color="primary lighten-2"
                        @click:clear="tooglePesquisaTamanhos"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-expand-transition>

                <v-card-text
                  :style="
                    exibir_pesquisa_tamanhos ? 'height: 322px' : 'height: 384px'
                  "
                  style="overflow-x: auto"
                  class="pa-0"
                >
                  <v-divider></v-divider>
                  <v-data-table
                    :search="pesquisa_tamanhos"
                    :headers="headers_tamanhos"
                    :items="tamanhos"
                    item-key="id"
                    v-model="tamanhos_selecionados"
                    hide-default-footer
                    show-select
                    disable-pagination
                  >
                    <template
                      v-slot:item.data-table-select="{
                        item,
                        isSelected,
                        select,
                      }"
                    >
                      <v-simple-checkbox
                        :value="isSelected"
                        :readonly="item.inativo"
                        :disabled="item.inativo"
                        @input="select($event)"
                        @click="selecionarTamanho(item, isSelected)"
                        v-ripple
                      ></v-simple-checkbox>
                    </template>
                    <template v-slot:item.tamanho="{ item }">
                      <td v-if="item.inativo" style="color: lightgray">
                        {{ item.tamanho }}
                      </td>
                      <td v-else>{{ item.tamanho }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div slot="botoes" class="pa-0" style="text-align: rigth">
          <v-btn depressed @click="fecharDialogoGrade">Cancelar</v-btn>
          <v-btn depressed color="primary" class="ml-4" @click="ordernarTamanhos"
            >Confirmar</v-btn
          >
        </div>

        <v-row v-show="loading_grade" class="justify-center align-center mt-5">
          <v-progress-circular
            indeterminate
            size="50"
            width="3"
            color="primary"
          ></v-progress-circular>
        </v-row>
      </as-dialogo>

      <as-dialogo
        ref="dialogoCores"
        title="Cadastro de Cor"
        max-width="400px"
        semPadding
        hideCloseButton
      >
        <v-form ref="formCores" v-model="form_valid_cores" lazy-validation>
          <v-container fluid>
            <v-row dense class="pa-2">
              <v-col cols="12">
                <v-text-field
                  label="Nome"
                  ref="nome"
                  v-model="cor.nome"
                  @keydown.prevent.enter="salvarCor"
                  :rules="regras_cores.nome"
                  @input="(value) => (cor.nome = value.toUpperCase())"
                  autofocus
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <div slot="botoes" class="pa-2">
          <v-btn depressed @click="$refs.dialogoCores.fechar()" class="mr-4"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="salvarCor"
            :loading="loading_cores"
            :disabled="loading_cores || !form_valid_cores"
            >Salvar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoTamanhos"
        title="Cadastro de Tamanho"
        max-width="400px"
        semPadding
        hideCloseButton
      >
        <v-form
          ref="formTamanhos"
          v-model="form_valid_tamanhos"
          lazy-validation
        >
          <v-container fluid>
            <v-row dense class="pa-2">
              <v-col cols="12">
                <v-text-field
                  label="Nome"
                  ref="nome"
                  v-model="tamanho.tamanho"
                  @keydown.prevent.enter="salvarTamanho"
                  :rules="regras_tamanhos.tamanho"
                  autofocus
                  @input="(value) => (tamanho.tamanho = value.toUpperCase())"
                  maxlength="3"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <div slot="botoes" class="pa-2">
          <v-btn depressed class="mr-4" @click="$refs.dialogoTamanhos.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="salvarTamanho"
            :loading="loading_tamanhos"
            :disabled="loading_tamanhos || !form_valid_tamanhos"
            >Salvar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoOrdenarTamanhos"
        title="Ordenação de Tamanhos"
        max-width="600px"
        semPadding
        hideCloseButton
      >
        <v-container fluid>
          <p>Arraste os tamanhos para a ordem que deseja que apareçam!</p>
          <v-row justify="center" dense>
            <v-col cols="6">
              <draggable
                class="list-group"
                tag="ul"
                v-model="tamanhos_selecionados"
                v-bind="dragOptions"
                @start="drag = true"
                @end="drag = false"
              >
                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                  <v-list-item class="list-group-item" v-for="element in tamanhos_selecionados" :key="element.order">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ element.tamanho }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </transition-group>
              </draggable>
            </v-col>
          </v-row>
        </v-container>
        <div slot="botoes">
          <v-btn depressed class="mr-4" @click="$refs.dialogoOrdenarTamanhos.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="confirmarGrade"
            >Salvar</v-btn
          >
        </div>
      </as-dialogo>
    </v-container>
  </div>
</template>

<script>
import Services from "../../services/services.js";
import ServiceCores from "../../services/cores.js";
import ServiceTamanhos from "../../services/tamanhos.js";
import ServiceProdutos from "../../services/produtos.js";

import draggable from "vuedraggable";

export default {
  name: "ProdutosCadastro",
  components: {
    draggable,
  },
  data() {
    return {
      pesquisa_cores: "",
      pesquisa_tamanhos: "",
      exibir_pesquisa_cores: false,
      exibir_pesquisa_tamanhos: false,
      loading: false,
      loading_grade: false,
      loading_cores: false,
      loading_tamanhos: false,
      loading_categorias: false,
      salvando: false,
      form_valid: false,
      form_valid_cores: false,
      form_valid_tamanhos: false,
      produto: {
        codigo: "",
        descricao: "",
        valor: 0,
        grade: [],
        cores: [],
        tamanhos: [],
        foto: "",
        video: "",
        categoria_id: null,
        quantidade_minima: 0,
        detalhes: "",
        multiplo: null
      },
      cores: [],
      tamanhos: [],
      user: {},
      headers_cores: [
        { text: "Cor", value: "nome", width: "100%", sortable: false },
      ],
      headers_tamanhos: [
        { text: "Tamanho", value: "tamanho", width: "100%", sortable: false },
      ],
      regras_produto: {
        codigo: [(value) => !!value || "Campo obrigatório"],
        descricao: [(value) => !!value || "Campo obrigatório"],
        valor: [
          (value) =>
            parseFloat(value.replace(",", ".")) > 0 ||
            "O valor não pode ser zero ou negativo",
          (value) => !!value || "Campo obrigatório",
        ],
        categoria: [(value) => !!value || "Campo obrigatório"],
        quantidade_minima: [(value) => !!value || "Campo obrigatório"],
        detalhes: [(value) => !!value || "Campo obrigatório"],
      },
      tamanhos_selecionados: [],
      cores_selecionadas: [],
      cor: {
        nome: "",
      },
      regras_cores: {
        nome: [(value) => !!value || "Campo obrigatório"],
      },
      tamanho: {
        tamanho: "",
      },
      regras_tamanhos: {
        tamanho: [(value) => !!value || "Informe o tamanho"],
      },
      grid: {
        sm4: false,
        offset_sm4: false,
        sm6: false,
        offset_sm3: false,
        sm8: false,
        offset_sm2: false,
        sm12: false,
      },
      categorias: [],
      drag: false,
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.$route.params.id) {
      this.editar(this.$route.params.id);
    }
    this.carregarCategorias();
    this.carregarCores();
    this.carregarTamanhos();
  },
  methods: {
    setCorTamanho() {
      this.tamanhos_selecionados = this.produto.tamanhos;
      // this.cores_selecionadas = this.produto.cores;
      this.cores_selecionadas = this.produto.cores.filter(
        (cor) => cor.tipo == 0
      );
    },
    tooglePesquisaCores() {
      this.exibir_pesquisa_cores = !this.exibir_pesquisa_cores;
      if (this.exibir_pesquisa_cores) {
        setTimeout(() => {
          this.$refs.pesquisa_cores.focus();
        }, 0);
      }
    },
    tooglePesquisaTamanhos() {
      this.exibir_pesquisa_tamanhos = !this.exibir_pesquisa_tamanhos;
      if (this.exibir_pesquisa_tamanhos) {
        setTimeout(() => {
          this.$refs.pesquisa_tamanhos.focus();
        }, 0);
      }
    },
    async editar(produto_id) {
      try {
        this.loading = true;
        let produto = await ServiceProdutos.editar(produto_id);
        this.produto = produto.data.produto;
      } catch (error) {
        console.log(error);
        this.$eventbus.error("Erro ao editar produto", error);
      } finally {
        this.loading = false;
      }
    },
    abrirDialogoGrade() {
      this.setCorTamanho();

      this.$refs.dialogoGrade.abrir();
    },
    async carregarCategorias() {
      try {
        this.loading_categorias = true;
        let response_categorias = await ServiceProdutos.listarCategorias();
        this.categorias = response_categorias.data.categorias;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar as categorias", error);
      } finally {
        this.loading_categorias = false;
      }
    },
    async carregarCores() {
      try {
        this.loading_grade = true;

        let response_cores = [];
        if (this.user.tipo == 'master') {
          response_cores = await ServiceCores.listarCoresProduto(this.$route.params.id);
        } else {
          response_cores = await ServiceCores.listar();
        }
        this.cores = response_cores.data.cores;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar cores", error);
      } finally {
        this.loading_grade = false;
      }
    },
    async carregarTamanhos() {
      try {
        this.loading_grade = true;

        let response_tamanhos = [];
        if (this.user.tipo == 'master') {
          response_tamanhos = await ServiceTamanhos.listarTamanhosProduto(this.$route.params.id);
        } else {
          response_tamanhos = await ServiceTamanhos.listar();
        }

        let tamanhos = response_tamanhos.data.tamanhos;
        tamanhos.forEach((tamanho) => {
          tamanho.inativo = false;
        });
        this.tamanhos = tamanhos;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar tamanhos", error);
      } finally {
        this.loading_grade = false;
      }
    },
    ordernarTamanhos() {
      if (
        this.tamanhos_selecionados.length > 0 &&
        this.cores_selecionadas.length > 0
      ) {
        this.tamanhos_selecionados = this.tamanhos_selecionados.map((tamanho, index) => {
          return { ...tamanho, order: index + 1 };
        });
        this.$refs.dialogoOrdenarTamanhos.abrir();
      } else {
        this.$eventbus.erro(
          "Você precisa preencher pelo menos uma cor e um tamanho"
        );
      }
    },
    confirmarGrade() {
      if (
        this.tamanhos_selecionados.length > 0 &&
        this.cores_selecionadas.length > 0
      ) {
        this.produto.tamanhos = this.tamanhos_selecionados;
        this.produto.cores = this.cores_selecionadas;
        this.$refs.dialogoOrdenarTamanhos.fechar();
        this.$refs.dialogoGrade.fechar();
      } else {
        this.$eventbus.erro(
          "Você precisa preencher pelo menos uma cor e um tamanho"
        );
      }
    },
    fecharDialogoGrade() {
      this.$refs.dialogoGrade.fechar();
      this.cores_selecionadas = [];
      this.tamanhos_selecionados = [];
    },
    async salvar() {
      if (this.$refs.form.validate()) {
        if (this.gradePreenchida) {
          try {
            this.salvando = true;

            let response = "";

            if (this.produto.id) {
              response = await ServiceProdutos.atualizar(
                this.produto.id,
                this.produto
              );
              this.$eventbus.notificar("Produto atualizado com sucesso");
            } else {
              response = await ServiceProdutos.salvar(this.produto);
              this.$eventbus.notificar("Produto salvo com sucesso");
            }

            if (this.user.tipo == 'master') {
              this.$router.push('/produtos');
            } else {
              this.$router.go(-1);
            }
          } catch (error) {
            if (error.response.data.status == 2) {
              this.$eventbus.erro("Código já cadastrado");
              this.$refs.codigo.focus();
            } else {
              this.$eventbus.erro("Erro ao salvar o produto", error);
            }
          } finally {
            this.salvando = false;
          }
        } else {
          this.$eventbus.erro(
            "Você precisa preencher pelo menos uma cor e um tamanho. Clique no botão TAMANHOS E CORES para completá-la."
          );
        }
      }
    },
    abrirDialogoCores() {
      this.cor = {
        nome: "",
      };
      this.$refs.dialogoCores.abrir();
    },
    async salvarCor() {
      if (this.$refs.formCores.validate()) {
        try {
          this.loading_cores = true;
          await ServiceCores.salvar(this.cor);
          this.$eventbus.notificar("Cor salva com sucesso");
        } catch (error) {
          console.log(error);
          this.$eventbus.erro("Erro ao salvar essa cor");
        } finally {
          this.loading_cores = false;
          this.$refs.dialogoCores.fechar();
          this.carregarCores();
        }
      }
    },
    abrirDialogoTamanhos() {
      this.tamanho = {
        tamanho: "",
      };
      this.$refs.dialogoTamanhos.abrir();
    },
    async salvarTamanho() {
      if (this.$refs.formTamanhos.validate()) {
        try {
          this.loading_tamanhos = true;
          await ServiceTamanhos.salvar(this.tamanho);
          this.$eventbus.notificar("Tamanho salvo com sucesso");
        } catch (error) {
          console.log(error);
          this.$eventbus.erro("Erro ao salvar esse tamanho", error);
        } finally {
          this.loading_tamanhos = false;
          this.$refs.dialogoTamanhos.fechar();
          this.carregarTamanhos();
        }
      }
    },
    removerCaracteres() {
      this.produto.codigo = this.produto.codigo.replace(/^[^A-Za-z0-9]+/, "");
      this.produto.codigo = this.produto.codigo.replace(
        /([^A-Za-z0-9/.-]+)/g,
        ""
      );
      this.produto.codigo = this.produto.codigo.toUpperCase();
    },
    converterInteiro() {
      this.produto.quantidade_minima = parseInt(this.produto.quantidade_minima);
    },
    selecionarTamanho(tamanho_selecionado, selecionado) {
      if (tamanho_selecionado.tipo == 1) {
        if (!selecionado) {
          this.tamanhos.forEach((tamanho) => {
            if (tamanho.id != tamanho_selecionado.id) {
              tamanho.inativo = true;
            }
          });
          this.tamanhos_selecionados = [];
          this.tamanhos_selecionados.push(tamanho_selecionado);
        } else {
          this.tamanhos.forEach((tamanho) => {
            tamanho.inativo = false;
          });
        }
      }
    },
    cancelar() {
      if (this.user.tipo == 'master'){
        this.$router.push('/produtos');
      } else {
        this.$router.go(-1);
      }
    }
  },
  computed: {
    gradePreenchida() {
      if (this.produto.cores.length > 0 && this.produto.tamanhos.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    tabela() {
      let tabela = {};

      if (this.produto.tamanhos.length <= 3) {
        tabela = {
          sm4: true,
        };
      }

      return (tabela = {});
    },

    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  watch: {
    produto: {
      handler: function(produto) {
        if (produto.tamanhos.length <= 2) {
          this.grid = {
            sm4: true,
            offset_sm4: false,
            sm6: false,
            offset_sm3: false,
            sm8: false,
            offset_sm2: false,
            sm12: false,
          };
        } else if (
          produto.tamanhos.length > 2 &&
          produto.tamanhos.length <= 5
        ) {
          this.grid = {
            sm4: false,
            offset_sm4: false,
            sm6: true,
            offset_sm3: false,
            sm8: false,
            offset_sm2: false,
            sm12: false,
          };
        } else if (
          produto.tamanhos.length > 5 &&
          produto.tamanhos.length <= 7
        ) {
          this.grid = {
            sm4: false,
            offset_sm4: false,
            sm6: false,
            offset_sm3: false,
            sm8: true,
            offset_sm2: false,
            sm12: false,
          };
        } else {
          this.grid = {
            sm4: false,
            offset_sm4: false,
            sm6: false,
            offset_sm3: false,
            sm8: false,
            offset_sm2: false,
            sm12: true,
          };
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
.tabela .theme--light.v-table tbody tr td:not(:last-child) {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.tabela .theme--light.v-table thead tr th:not(:last-child) {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.zui-table {
  border: none;
  border-right: solid 1px lightgray;
  border-collapse: separate;
  border-spacing: 0;
  letter-spacing: 0.5px;
}
.zui-table thead th {
  border: none;
  padding: 10px;
  text-align: left;
  white-space: nowrap;
  color: white !important;
}
.zui-table tbody td {
  border-bottom: solid 1px lightgray;
  color: white;
  padding: 10px;
  white-space: nowrap;
  text-align: center;
}
.zui-wrapper {
  position: relative;
}
.zui-scroller {
  border-radius: 4px 4px 0px 0px;
  overflow-x: scroll;
  overflow-y: visible;
}
.zui-table .zui-sticky-col {
  border-left: solid 1px lightgray;
  border-right: solid 1px lightgray;
  left: 0;
  position: sticky;
  top: auto;
  background-color: white;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
  border: 1px solid lightgray;
  margin: 3px 0 3px 0;
}
.list-group-item i {
  cursor: pointer;
  border: 1px solid lightgray;
  margin: 3px 0px;
}
</style>
